import { event, isArray } from "jquery";
import { debounce } from "lodash";

export default {
	data() {
		return {
			modalIsOpen: false,
			isValid: false,
			showError: false,
			showErrorOnModal: false,
			isPercentFull: false,
			hasFinishedSteps: false,
			errorMessage: "",
			modalErrorMessage: "",
			tipo_atual: "",
			modalValueIsValid: false,
			show: false,
			search: "",
			loading: false,
			objEdicao: null,
			modalState: "",
			stepAnterior: null,
			objetivoFiltrado: "",
			baseURL: window.location.origin,
			showOptions: "",
			showOptionsFirst: false,
			isSaveBtn: false,
			hasSameValue: false,
			product_type_name: "",
			stepList: [
				{ id: 1, enabled: true, active: true },
				{ id: 2, enabled: true, active: false },
				{ id: 3, enabled: true, active: false },
				{ id: 4, enabled: true, active: false },
				{ id: 5, enabled: true, active: false },
				{ id: 6, enabled: true, active: false },
				{ id: 7, enabled: true, active: false },
				{ id: 8, enabled: true, active: false },
				{ id: 9, enabled: true, active: false },
			],

			campos_objetivo: {
				pr_renda_fixa: "",
				pr_renda_variavel: "",
				pr_renda_variavel_eua: "",
				pr_renda_variavel_br: "",
				pr_acoes: "",
				pr_fiis: "",
				pr_reits: "",
				pr_stocks: "",
			},
			objetivos: {
				acoes: [],
				fiis: [],
				stocks: [],
				reits: [],
				tesouro_direto: [],
			},
			concluido: true,
			novoObjetivo: {
				nome: "",
				porcentagem: 0,
			},
			step: {
				id: 1,
				tipo: "",
				nomeCorreto: "",
			},
			dataToSave: {},
			options: [],
			optionsRendaFixa: [
				{
					value: "Tesouro IPCA+",
					label: "Tesouro IPCA+",
					ticker_symbol: "Tesouro IPCA+",
				},
			],
			isLoading: false,
			selected: null,
			pastTotalValue: 0,
			dadosRequisicaoInicial: null,
			protocol: window.location.protocol,
		};
	},
	async mounted() {
		document.addEventListener("click", (e) => this.outsideClick(e));
		// await this.getObjectiveIncomplete();
		await this.setInitialLocalStorageState();



	},

	watch: {
		step(newValue, oldValue) {
			if (newValue.id <= 4 && newValue.id < oldValue.id) {
				this.isValid = true;
			}
		},

		valor_total_computado(newValue, oldValue) {
			if (!this.valor_total_computado) return;
			this.checkSumValueInInlineSteps();
		},
		stepList(newValue, oldValue) {
			let stepAtivos = newValue.filter((i) => i.enabled);
			const ultimoObjetoAtivo = stepAtivos.slice(-1)[0];
			if (ultimoObjetoAtivo && ultimoObjetoAtivo.id === this.step?.id) {
				this.isSaveBtn = true;
			} else {
				this.isSaveBtn = false;
			}
		},

		lastStep(newValue, oldValue) {
			const botaoOld = document.querySelector(`.step-${oldValue} .btn-update`);
			const botaoNew = document.querySelector(`.step-${newValue} .btn-update`);
			botaoOld.setAttribute("type", "button");
			botaoOld.innerText = "Avançar";
			botaoNew.setAttribute("type", "submit");
			botaoNew.innerText = "Enviar";
		},
	},

	computed: {
		valor_total_computado() {
			const objetivoAtual = this.objetivos[this.step?.tipo];
			if (!objetivoAtual || !Array.isArray(objetivoAtual)) {
				return 0;
			}
			const porcentagens = objetivoAtual?.map((objetivo) =>
				Number(objetivo.porcentagem_desejada)
			);
			const total = porcentagens.reduce(
				(acc, porcentagem) => acc + porcentagem,
				0
			);
			// return Math.round(total);
			return Math.round((total + Number.EPSILON) * 100) / 100;
		},
		quantidadeSteps() {
			const size = 9;
			return size;
		},
		noHaveRendaVariavel() {
			return this.campos_objetivo.pr_renda_variavel == 0;
		},
		noHaveRendaFixa() {
			return this.campos_objetivo.pr_renda_fixa == 0;
		},
		noHaveBr() {
			return this.campos_objetivo.pr_renda_variavel_br == 0;
		},
		noHaveEUA() {
			return this.campos_objetivo.pr_renda_variavel_eua == 0;
		},

		noHaveAcoes() {
			return this.campos_objetivo.pr_acoes == 0;
		},

		noHaveFiis() {
			return this.campos_objetivo.pr_fiis == 0;
		},

		noHaveReits() {
			return this.campos_objetivo.pr_reits == 0;
		},
		noHaveStocks() {
			return this.campos_objetivo.pr_stocks == 0;
		},

		texto() {
			if (this.step?.tipo == "acoes") {
				return "Qual o seu objetivo com esta ação?";
			} else if (this.step?.tipo == "fiis") {
				return "Qual o seu objetivo com este FII?";
			} else if (this.step?.tipo == "stocks") {
				return "Qual o seu objetivo com este Stock?";
			} else if (this.step?.tipo == "reits") {
				return "Qual o seu objetivo com este Reit";
			} else if (this.step?.tipo == "tesouro_direto") {
				return "Qual o seu objetivo com este Titulo de renda fixa?";
			} else {
				return "";
			}
		},
	},

	methods: {
		/* funções responsáveis por gerenciar dados salvos no localstorage */
		triggerError() {
			// Simular um erro (não faça isso em código de produção)
			console.log(variavelNaoDefinida); // Isso gerará um erro
		},
		async setInitialLocalStorageState() {
			this.isLoadingStorage = true;
			this.dataToSave = await this.getObjectiveIncomplete();
			if (!this.dataToSave) return;
			this.step = this.dataToSave.step;
			this.stepList = this.dataToSave.stepList;
			this.isSaveBtn = this.dataToSave.isSaveBtn;
			this.campos_objetivo = this.dataToSave.campos_objetivo;
			this.objetivos = this.dataToSave.objetivos;
			this.options = this.dataToSave.options;
			this.checkIfExistValidValuesOnAStep(this.dataToSave.step);
			this.defineTypeProduct(this.step?.tipo);
		},
		async getObjectiveIncomplete() {

			try {
				const { data } = await axios.get(
					`${this.baseURL}/api/step_cadastro_objetivo/`
				);
				console.log(data)
				return data[0];
			} catch (error) {
				console.log(error);
			}
		},
		async saveActualStateOnLocalStorage(obj) {
			try {
				const response = await this.getObjectiveIncomplete();
				if (response) {
					const { data } = await axios.put(
						`${this.baseURL}/api/step_cadastro_objetivo/${response.id}/`,
						{
							...obj,
						}
					);
					return;
				}
				const { data } = await axios.post(
					`${this.baseURL}/api/step_cadastro_objetivo/`,
					{
						...obj,
					}
				);
			} catch (error) {
				console.log(error);
			}
		},


		dropdownShouldOpen(VueSelect) {
			if (this.options.length) {
				return VueSelect.open;
			}

			return VueSelect.search.length !== 0 && VueSelect.open;
		},

		removeLocalStorage() {
			if (!localStorage.getItem("estadoAtual")) return;
			localStorage.removeItem("estadoAtual");
		},

		checkIfExistValidValuesOnAStep(stepObj) {
			const stepsInline = [5, 6, 7, 8, 9];
			const isInlineSteps = stepsInline.some((i) => i === stepObj.id);
			if (stepObj.id === 1) {
				if (
					this.campos_objetivo.pr_renda_variavel == "" &&
					this.campos_objetivo.pr_renda_fixa == ""
				)
					return;
				this.isValid = true;
			} else if (stepObj.id === 2) {
				if (
					this.campos_objetivo.pr_renda_variavel_br == "" &&
					this.campos_objetivo.pr_renda_variavel_eua == ""
				)
					return;
				this.isValid = true;
			} else if (stepObj.id === 3) {
				if (
					this.campos_objetivo.pr_acoes == "" &&
					this.campos_objetivo.pr_fiis == ""
				)
					return;
				this.isValid = true;
			} else if (stepObj.id === 4) {
				if (
					this.campos_objetivo.pr_reits == "" &&
					this.campos_objetivo.pr_stocks == ""
				)
					return;
				this.isValid = true;
			} else if (isInlineSteps) {
				if (
					this.valor_total_computado !== 100 ||
					this.valor_total_computado > 100
				)
					return;
				this.isValid = true;
				this.modalValueIsValid = true;
			}
		},

		/* Funções de controle dos steps do wizard*/
		verifyStepAndSetThePatterns(current, tipo = "default") {
			if (this.step?.id == current) {
				this.step.id = current;
				this.step.tipo = tipo;
				this.tipo_atual = tipo;
				return true;
			}

			return false;
		},



		changeStep(step) {
			this.nextStep = step;
			//objeto para setar o tipo de produto
			const stepProps = {
				5: { tipo: "acoes", nome: "Ação" },
				6: { tipo: "fiis", nome: "FIIs" },
				7: { tipo: "stocks", nome: "Stock" },
				8: { tipo: "reits", nome: "REIT" },
				9: { tipo: "tesouro_direto", nome: "Tesouro" },
			};

			const stepObj = { id: step };
			const tipo = stepProps[step]?.tipo;
			const nomeCorreto = stepProps[step]?.nome;

			tipo ? (stepObj.tipo = tipo) : (stepObj.tipo = "");
			nomeCorreto
				? (stepObj.nomeCorreto = nomeCorreto)
				: (stepObj.nomeCorreto = "");

			this.step = stepObj;
			this.defineTypeProduct(this.step?.tipo);
			this.dataToSave = {
				step: this.step, //objeto
				stepList: this.stepList, //objeto
				isSaveBtn: this.isSaveBtn, // booleano
				objetivos: this.objetivos, //objeto
				campos_objetivo: this.campos_objetivo, // objeto
				options: this.options,
			};

			this.saveActualStateOnLocalStorage(this.dataToSave);
			this.checkIfExistValidValuesOnAStep(this.step);
		},

		getActiveStep() {

			const habilitados = this.stepList.filter((i) => i.enabled);
			const indexAtivo = habilitados.findIndex((i) => i.active);

			return { active: indexAtivo, enableds: habilitados };
		},

		nextStepFn() {
			const _next = this.getActiveStep().active + 1
			const next = this.getActiveStep()
				.enableds.at(_next);

			if (!next) return;

			this.stepList = this.stepList.map((i) => {
				i.id === next.id ? (i.active = true) : (i.active = false);
				return i;
			});

			return next;
		},

		toNextStep() {
			const nextID = this.nextStepFn()?.id;
			nextID && this.changeStep(nextID);
		},

		previousStep() {
			const prev = this.getActiveStep().enableds.at(
				this.getActiveStep().active - 1
			);

			this.stepList = this.stepList.map((i) => {
				i.id === prev.id ? (i.active = true) : (i.active = false);
				return i;
			});

			return prev;
		},

		toPreviousStep() {
			this.changeStep(this.previousStep().id);
		},

		disableSteps(array) {
			this.stepList = this.stepList.map((i) => {
				const a = array.forEach((n) => n === i.id && (i.enabled = false));

				return i;
			});
		},

		enableSteps(array) {
			this.stepList = this.stepList.map((i) => {
				const a = array.forEach((n) => n === i.id && (i.enabled = true));
				return i;
			});
		},

		async updateValueStep() {
			const t = this

			try {
				if (this.step?.id == this.lastStep) return;
				this.isPercentFull = false;
				this.isValid = false;

				this.showError = false;
				this.modalValueIsValid = false;
				this.isExclude = false;



				// STEP 1
				if (this.step?.id === 1) {
					if (this.noHaveRendaVariavel) {
						this.disableSteps([2, 3, 4, 5, 6, 7, 8]);
					} else {
						// Enabled
						this.enableSteps([2, 3, 4, 5, 6, 7, 8]);
					}

					this.noHaveRendaFixa ? this.disableSteps([9]) : this.enableSteps([9]);
					t.toNextStep();
					console.log("passo 1")
					return;
				}

				// STEP 2
				else if (this.step?.id === 2) {
					if (this.noHaveBr && !this.noHaveEUA) {
						this.disableSteps([3, 5, 6]);
						console.log("this.noHaveBR");
					} else if (this.noHaveEUA && !this.noHaveBr) {
						this.disableSteps([4, 7, 8]);
						console.log("this.noHaveEUA");
					}
					// Enabled ================================
					if (!this.noHaveBr && this.noHaveEUA) {
						this.enableSteps([3, 5, 6]);
						console.log("!this.noHaveBR");
					} else if (!this.noHaveEUA && this.noHaveBr) {
						this.enableSteps([4, 7, 8]);
						console.log("!this.noHaveEUA");
					} else if (!this.noHaveEUA && !this.noHaveBr) {
						this.enableSteps([3, 4, 5, 6, 7, 8]);
						console.log("!this.noHaveEUA");
					}
				}

				// STEP 3
				else if (this.step?.id === 3) {
					if (this.noHaveFiis && this.noHaveEUA) {
						console.log("this.noHaveFiis && this.noHaveEUA");
						this.disableSteps([4]);
						this.noHaveRendaFixa
							? this.disableSteps([6, 7, 8, 9])
							: this.enableSteps([6, 7, 8, 9]);
					} else if (this.noHaveAcoes && this.noHaveEUA) {
						console.log("this.noHaveAcoes && this.noHaveEUA");
						this.disableSteps([4, 5]);
						this.noHaveRendaFixa && this.disableSteps([7, 8, 9]);
					} else if (this.noHaveEUA) {
						this.disableSteps([4]);
						console.log("this.noHaveEUA");
					} else if (this.noHaveAcoes) {
						this.disableSteps([5]);
						console.log("this.noHaveAcoes");
					} else if (this.noHaveFiis) {
						this.disableSteps([6]);
						console.log("(this.noHaveFiis");
					}

					// Enabled ================================
					if (!this.noHaveFiis && !this.noHaveEUA) {
						this.enableSteps([4]);
						!this.noHaveRendaFixa && this.enableSteps([6, 7, 8, 9]);
						console.log("!this.noHaveFiis && !this.noHaveEUA");
					} else if (!this.noHaveAcoes && !this.noHaveEUA) {
						this.enableSteps([4, 5]);
						!this.noHaveRendaFixa && this.enableSteps([7, 8, 9]);
						console.log("!this.noHaveAcoes && !this.noHaveEUA");
					} else if (!this.noHaveEUA) {
						this.enableSteps([4]);
						console.log("!this.noHaveEUA");
					} else if (this.noHaveEUA && !this.noHaveAcoes) {
						this.enableSteps([5]);
						console.log("this.noHaveEUA && !this.noHaveAcoes");
					} else if (this.noHaveEUA && !this.noHaveFiis) {
						this.enableSteps([6]);
						console.log("this.noHaveEUA && !this.noHaveFiis");
					} else if (!this.noHaveAcoes) {
						this.enableSteps([5]);
						console.log("!this.noHaveAcoes");
					} else if (!this.noHaveFiis) {
						this.enableSteps([6]);
						console.log("(!this.noHaveFiis");
					} else if (!this.noHaveAcoes && !this.noHaveFiis) {
						this.enableSteps([5, 6]);
						console.log("!this.noHaveAcoes && this.noHaveFiis");
					}
				}

				// STEP 4
				else if (this.step?.id === 4) {
					if (this.noHaveStocks && this.noHaveBr) {
						this.disableSteps([5, 6, 7]);
						this.noHaveRendaFixa && this.disableSteps([9]);
						console.log("this.noHaveStocks && this.noHaveBr");
					} else if (this.noHaveReits && this.noHaveBr) {
						this.disableSteps([5, 6]);
						this.noHaveRendaFixa && this.disableSteps([8, 9]);
						console.log("this.noHaveReits && this.noHaveBr");
					} else if (this.noHaveBr) {
						this.disableSteps([5, 6]);
						console.log("this.noHaveBr");
						// this.noHaveRendaFixa && (this.lastStep = this.lastStep);
					} else if (this.noHaveAcoes) {
						this.disableSteps([5]);
						console.log("this.noHaveAcoes");
					} else if (this.noHaveFiis) {
						this.disableSteps([6]);
						console.log("(this.noHaveFiis");
					} else if (this.noHaveStocks) {
						this.disableSteps([7]);
						console.log("this.noHaveStocks");
					} else if (this.noHaveReits) {
						this.disableSteps([8]);
						console.log("this.noHaveReits");
					}

					// Enabled ================================
					if (
						!this.noHaveStocks &&
						!this.noHaveBr &&
						!this.noHaveAcoes &&
						!this.noHaveFiis
					) {
						this.enableSteps([5, 6, 7]);
						!this.noHaveRendaFixa && this.enableSteps([9]);
					} else if (
						!this.noHaveReits &&
						!this.noHaveBr &&
						!this.noHaveAcoes &&
						!this.noHaveFiis
					) {
						this.enableSteps([5, 6]);
						!this.noHaveRendaFixa && this.enableSteps([8, 9]);
						console.log("!this.noHaveReits && !this.noHaveBr");
					} else if (!this.noHaveBr && !this.noHaveAcoes && !this.noHaveFiis) {
						this.enableSteps([5, 6]);
						// this.noHaveRendaFixa && (this.lastStep = this.lastStep);
						console.log("!this.noHaveBr");
					} else if (!this.noHaveAcoes) {
						this.enableSteps([5]);
						console.log("!this.noHaveAcoes");
					} else if (!this.noHaveFiis) {
						this.enableSteps([6]);
						console.log("!this.noHaveFiis");
					} else if (!this.noHaveStocks) {
						this.enableSteps([7]);
						console.log("!this.noHaveStocks");
					} else if (!this.noHaveReits) {
						this.enableSteps([8]);
						console.log("!this.noHaveReits");
					} else if (!this.noHaveStocks && !this.noHaveReits) {
						this.enableSteps([7, 8]);
						console.log("!this.noHaveAcoes && this.noHaveFiis");
					} else if (this.noHaveBr && !this.noHaveStocks) {
						this.enableSteps([7]);
						console.log("this.noHaveBr && !this.noHaveStocks");
					} else if (this.noHaveBr && !this.noHaveReits) {
						this.enableSteps([8]);
						console.log("this.noHaveBr && !this.noHaveReits");
					}
				}

				// STEP 5
				else if (this.step?.id === 5) {
					if (this.noHaveFiis && this.noHaveEUA) {
						this.disableSteps([6, 7, 8]);
						this.noHaveRendaFixa && this.disableSteps([6, 7, 8, 9]);
					} else if (this.noHaveFiis && this.noHaveReits) {
						this.disableSteps([6]);
						this.noHaveRendaFixa && this.disableSteps([8, 9]);
					} else if (this.noHaveFiis && this.noHaveStocks) {
						this.disableSteps([6, 7]);
						this.noHaveRendaFixa && this.disableSteps([9]);
					} else if (this.noHaveReits && this.noHaveStocks) {
						this.noHaveRendaFixa && this.disableSteps([7, 8, 9]);
					}

					// Enabled ================================

					if (!this.noHaveFiis && !this.noHaveEUA) {
						this.enableSteps([6, 7, 8]);
						!this.noHaveRendaFixa && this.enableSteps([6, 7, 8, 9]);
					} else if (!this.noHaveFiis && !this.noHaveReits) {
						this.enableSteps([6]);
						!this.noHaveRendaFixa && this.enableSteps([8, 9]);
					} else if (!this.noHaveFiis && !this.noHaveStocks) {
						this.enableSteps([6, 7]);
						!this.noHaveRendaFixa && this.enableSteps([9]);
					} else if (!this.noHaveReits && !this.noHaveStocks) {
						!this.noHaveRendaFixa && this.enableSteps([7, 8, 9]);
					} else if (this.noHaveEUA && !this.noHaveFiis && !this.noHaveAcoes) {
						this.enableSteps([5, 6]);
						console.log(
							"this.noHaveEUA && !this.noHaveFiis && !this.noHaveAcoes"
						);
					}
				}

				// STEP 6
				else if (this.step?.id === 6) {
					if (this.noHaveEUA) {
						this.disableSteps([7, 8]);
					} else if (this.noHaveReits) {
						this.noHaveRendaFixa && this.disableSteps([8, 9]);
					} else if (this.noHaveStocks) {
						this.disableSteps([7]);
						this.noHaveRendaFixa && this.disableSteps([9]);
					}

					// Enabled ================================
					if (!this.noHaveEUA && !this.noHaveStocks && !this.noHaveReits) {
						this.enableSteps([7, 8]);
						console.log("!this.noHaveEUA && !this.noHaveStocks");
					} else if (!this.noHaveReits) {
						!this.noHaveRendaFixa && this.enableSteps([8, 9]);
					} else if (!this.noHaveStocks) {
						this.enableSteps([7]);
						console.log("!this.noHaveStocks");
						!this.noHaveRendaFixa && this.enableSteps([9]);
					}
				}

				// STEP 7
				else if (this.step?.id === 7) {
					if (this.noHaveReits) {
						this.disableSteps([8]);
					}
					// Enabled ================================

					if (!this.noHaveReits) {
						this.enableSteps([8]);
					}
				}
				// } else if (this.step?.id === 8) {
				// } else if (this.step?.id === 9) {
				// }

				t.toNextStep();
				//  1 step
				//  CHECK se renda fixa 100 e renda variavel 0  => pula pro step 9

				// 1 step
				// CHECK se renda variavel for 100 e fixa for 0 => nao passa pro step 9
				//  CHECK => botao submit fica no step 8

				// 2 step

				// CHECK se EUA for igual a 100 e brasil for igual a 0 nao passa no step 3  NOHAVEBR
				// CHECK se nao passar no step 3 consequentemente nao passa no step 5 e 6

				// CHECK se brasil for igual a 100 e EUA for 0  nao passa no step 4
				// CHECK consequentemente nao passa no 7 nem no 8

				// 3 step
				// se for exibido
				// CHECK se açoes for igual a 100 e FIIs for igual 0
				// nao passa no step 6
				// CHECK se FIIs for igual a 100 e açoes for igual a 0
				// nao passa no step 5

				// 4 step
				// CHECK se stocks for igual a 100 e REITS for igual a 0
				// nao passa no step 8
				// CHECK se REITS for igual a 100 e STOCKS for igual a 0
				// nao passa no step 7
			}
			catch (error) {
				GLOBAL.showToastify(`${error}`, "#DE4B4F");

			}


		},

		/* Funções que previne a adição de ativos que já existem no objetivo*/
		checkIfStringExistsOnObject() {
			if (this.modalState == "adicionar") {
				console.log(this.objetivos[this.tipo_atual])
				let equal = this.objetivos[this.tipo_atual].some(
					(i) => i.ticker_symbol == this.novoObjetivo.nome
				);

				if (equal) {
					this.hasSameValue = true;
					return;
				}
				this.hasSameValue = false;
			} else if (this.modalState == "editar") {

				let equal = this.objetivos[this.tipo_atual].some(
					(i) =>
						i.ticker_symbol == this.novoObjetivo.nome &&
						i.ticker_symbol != this.objEdicao.ticker_symbol.ticker_symbol
				);
				if (equal) {
					this.hasSameValue = true;
					this.modalValueIsValid = false;
					return;
				}
				this.novoObjetivo.porcentagem = this.objEdicao.porcentagem_desejada;
				this.hasSameValue = false;
				this.modalValueIsValid = true;
			}
		},
		preventInsertTheSameTickerSymbol() {
			this.checkIfStringExistsOnObject();
			if (this.hasSameValue) {
				this.showErrorOnModal = true;
				this.modalErrorMessage = "Esse ativo já foi adicionado antes";
				this.novoObjetivo.porcentagem = null;
				this.modalValueIsValid = false;
				return;
			} else {
				this.showErrorOnModal = false;
				this.modalErrorMessage = "";
			}
		},

		handleSearchSelect(opcaoSelecionada) {
			if (!opcaoSelecionada.value) return;
			this.novoObjetivo.nome = opcaoSelecionada.value;

			this.preventInsertTheSameTickerSymbol();
		},

		defineTypeProduct(variable) {
			switch (variable) {
				case "acoes":
					this.product_type_name = "Ações";
					break;
				case "fiis":
					this.product_type_name = "FII - Fundo de Investimento Imobiliário";
					break;
				case "stocks":
					this.product_type_name = "Stock";
					break;
				case "reits":
					this.product_type_name = "REIT";
					break;
			}
		},

		limitQuantityNumberAfterVirgula(input1 = null, input2 = null) {
			if (
				input1 &&
				input1.value !== null &&
				input1.value.toString().indexOf(".") !== -1
			) {
				const partes = input1.value.toString().split(".");
				if (partes[1].length > 2) {
					input1.value = parseFloat(partes[0] + "." + partes[1].substr(0, 2));

					this.novoObjetivo.porcentagem = input1.value;
				}
			}

			if (
				input2 &&
				input2.value !== null &&
				input2.value.toString().indexOf(".") !== -1
			) {
				const partes = input2.value.toString().split(".");
				if (partes[1].length > 2) {
					input2.value = parseFloat(partes[0] + "." + partes[1].substr(0, 2));
				}
			}
		},
		/* Funções responsáveis por calcular valor dos objetivos*/

		checkSumValueInNormalSteps({ currentTarget, target }) {
			const cardItem = document.querySelector(`.step-${this.step?.id}`);
			const pai = cardItem.parentElement;
			const numeroPermitido = 100;
			const inputs = [...cardItem.querySelectorAll("input")];
			const [input1, input2] = inputs;
			let soma;
			// if (!currentTarget) return;

			if (currentTarget.value > numeroPermitido) currentTarget.value = "";
			this.limitQuantityNumberAfterVirgula(input1, input2);
			this.defineDynamicValueFromInputsInNormalSteps(
				currentTarget,
				input1,
				input2
			);
			soma = Number(input1.value) + Number(input2.value);
			this.compareSumValuesInNormalSteps(soma);
		},

		defineDynamicValueFromInputsInNormalSteps(
			elAtivo,
			firstInput,
			secondInput
		) {
			const attrName1 = firstInput.getAttribute("name");
			const attrName2 = secondInput.getAttribute("name");
			if (elAtivo == firstInput) {
				secondInput.value = (100 - firstInput.value).toFixed(2);
				this.campos_objetivo[attrName1] = parseFloat(firstInput.value);
				this.campos_objetivo[attrName2] = parseFloat(secondInput.value);
			} else if (elAtivo == secondInput) {
				firstInput.value = (100 - secondInput.value).toFixed(2);
				this.campos_objetivo[attrName1] = parseFloat(firstInput.value);
				this.campos_objetivo[attrName2] = parseFloat(secondInput.value);
			}
		},

		compareSumValuesInNormalSteps(soma) {
			if (soma > 100 || soma != 100) {
				this.isValid = false;
				this.showError = true;
				this.errorMessage = "O somatório precisa ser igual a 100%";
				return;
			}
			this.isValid = true;
		},

		checkSumValueInInlineSteps() {
			const val = +this.valor_total_computado.toFixed(2)

			if (
				val > 100 ||
				val !== 100
			) {
				this.isValid = false;
				this.isPercentFull = false;
				this.showError = true;
				this.errorMessage = "O somatório precisa ser igual a 100%";
			} else if (val == 100) {
				this.isValid = true;
				this.isPercentFull = true;
			}
		},

		defineTypeProduct(variable) {
			switch (variable) {
				case "acoes":
					this.product_type_name = "Ações";
					break;
				case "fiis":
					this.product_type_name = "FII - Fundo de Investimento Imobiliário";
					break;
				case "stocks":
					this.product_type_name = "Stock";
					break;
				case "reits":
					this.product_type_name = "REIT";
					break;

				case "tesouro_direto":
					this.product_type_name = "TesouroDireto";
					break;
			}
		},

		/* Funções responsáveis pelo pesquisar e setar as options dentro do Choices */

		async saveActualStep() {
			this.loading = true;
			axios
				.post(`${this.baseURL}/salvar_step/`, {
					step: this.step, //objeto
					stepList: this.stepList, //objeto
					isSaveBtn: this.isSaveBtn, // booleano
					objetivos: this.objetivos, //objeto
					campos_objetivo: this.campos_objetivo, // objeto
				})
				.then(({ data }) => {
					return data;
				})
				.catch((error) => {
					GLOBAL.showToastify(error, "#DE4B4F");
					console.error(error);
					return;
				});
		},

		/**
		 * @description função responsável pelo evento de pesquisar dentro do vue select
		 * @param {string} search
		 * @param {boolean} loading
		 **/

		onSearch(search, loading) {
			if (this.step?.id === 9) return;
			if (search.length) {
				loading(true);
				this.getDataOnSearchSelect(loading, search, this);
			}
		},

		/**
		 * @description função responsável por fazer requisiçoes para API de acordo com a valor de busca, possui debounce.
		 * @param {string} search
		 * @param {boolean} loading
		 **/

		getDataOnSearchSelect: debounce(async function (loading, search) {
			try {
				let data;
				if (this.tipo_atual == "tesouro_direto") {
					const response = await fetch(
						`${this.baseURL}/api/tesouro_direto/?ticker_symbol=${search}`
					);
					data = await response.json();
				} else {
					const response = await fetch(
						`${this.baseURL}/api/${this.tipo_atual}/?ticker_symbol=${search}`
					);
					data = await response.json();
				}
				this.options = data.map(({ ticker_symbol }) => ({
					value: ticker_symbol,
					label: ticker_symbol,
					ticker_symbol: ticker_symbol,
				}));
				loading(false);
				this.isLoading = false;
			} catch (error) {
				GLOBAL.showToastify(error);
				console.error(error);
				loading(false);
				this.isLoading = false;
			} finally {
				loading(false);
				this.isLoading = false;
			}
		}, 600),

		/* Funções responsável por controlar array do objeto de edição */
		setAEditObjectiveToArray(id) {
			this.modalIsOpen = true;
			const { tipo } = this.step;
			const filterObjetivo = this.objetivos[tipo].filter((item) => {
				return item.id == id;
			});
			this.objEdicao = filterObjetivo[0];
			this.setValuesOnEditStateModal(filterObjetivo);
		},

		setNewObjectiveValueInOnKeyupEdit(e, cancelar) {
			const tipo = this.step?.tipo ?? "";
			if (cancelar || !tipo) {
				// Se cancelar ou tipo não estiver definido, sai da função
				return;
			}

			if (e.target) {
				e.preventDefault();
				this.limitQuantityNumberAfterVirgula(e.target);
				const updatedObjectives = this.objetivos[tipo].map((item) => {
					if (item.id === this.objEdicao.id) {
						const porcentagem =
							this.novoObjetivo.porcentagem ?? item.porcentagem_desejada;
						return { ...item, porcentagem_desejada: porcentagem };
					}
					return item;
				});
				this.objetivos[tipo] = updatedObjectives;

				this.validateModalFieldsOnEdit(e.target);
			}
		},

		updateObjectiveValue(item) {
			return {
				...item,
				porcentagem_desejada: this.novoObjetivo.porcentagem,
			};
		},

		setValuesOnEditStateModal(array) {
			this.novoObjetivo.nome = array[0].ticker_symbol;
			this.novoObjetivo.porcentagem = array[0].porcentagem_desejada;
		},

		/** 
		*Função responsável por ativar o modal e suas respectivas ações.
		* @param {string} valor
		* @param {string} id
		*/

		activateModal(valor, id) {
			this.modalIsOpen = true;
			this.modalState = valor;
			const tipo = this.step?.tipo;
			switch (this.modalState) {
				case "adicionar":
					this.options = [];
					this.novoObjetivo = {
						nome: "",
						porcentagem: "",
					};
					this.modalValueIsValid = false;
					this.hasSameValue = false;
					this.showErrorOnModal = false;
					break;
				case "editar":
						this.modalValueIsValid = true;
						this.hasSameValue = false;
						this.showErrorOnModal = false;
					// this.pastTotalValue = this.valor_total_computado;
					const nomeAtivo = this.objetivos[this.step?.tipo]
						.filter((i) => i.id === id)
						.reduce((acc, i) => (acc = i), {});

					this.options = [
						{
							value: nomeAtivo.ticker_symbol,
							label: nomeAtivo.ticker_symbol,
						},
					];

					this.setAEditObjectiveToArray(id);
					break;
			}
		},

		/** 
		 * Função responsável por definir o ticker_symbol na hora de editar um ativo.
		 */

		defineTickerSymbolInEdit() {
			if (this.novoObjetivo.nome.ticker_symbol) {
				return this.novoObjetivo.nome.ticker_symbol;
			} else if (this.novoObjetivo.nome.value) {
				return this.novoObjetivo.nome.value;
			} else {
				return this.novoObjetivo.nome;
			}

		},


		/**
		 * Função responsável por editar um ativo no modal de objetivo.
 
		 */
		async editAExistantObjetive() {
			const { tipo } = this.step;
			const objetivosFiltrados = this.objetivos[tipo].map((item) => {
				if (item.id == this.objEdicao.id) {
					return {
						...item,
						ticker_symbol: this.defineTickerSymbolInEdit(),
						porcentagem_desejada: this.novoObjetivo.porcentagem,
					};
				}
				return item;
			});
			this.objetivos[tipo] = objetivosFiltrados;
			this.dataToSave.objetivos = this.objetivos;
			await this.saveActualStateOnLocalStorage(this.dataToSave);
			this.checkSumValueInInlineSteps();
			this.modalIsOpen = false;
		},

		/**
		 * Função responsável por salvar um ativo no modal de objetivo
		 * @param {*} event 
		 */
		async saveANewObjective(event) {
			if(!this.product_type_name) return
			const modalResponsavel = event.currentTarget.closest(`.modal-adicao`);
			const { tipo } = this.step;
			const objetivosAtuais = this.objetivos[tipo];
			let found = false;
			this.objetivos[tipo] = [
				...objetivosAtuais,
				{
					id: this.protocol === "https:" ? crypto.randomUUID() : GLOBAL.generateUUID(),
					ticker_symbol: this.novoObjetivo.nome,
					porcentagem_desejada: this.novoObjetivo.porcentagem,
					tipo_ativo: `${this.tipo_atual != "tesouro_direto" ? "Variavel" : "Fixa"
						}`,
					product_type_name: this.product_type_name,
				},
			];
			this.dataToSave.objetivos = this.objetivos;
			this.saveActualStateOnLocalStorage(this.dataToSave);
			this.pastTotalValue = 0;
			this.checkSumValueInInlineSteps();
			this.resetModalForm();
			this.modalIsOpen = false;
		},

		/**
		 * Função responsável por remover um ativo no modal de objetivo
		 * @param {*} id 
		 */
		async removeObjective(id) {
			const { tipo } = this.step;
			this.objetivos[tipo] = this.objetivos[tipo].filter((item) => {
				return item.id !== id;
			});

			this.checkSumValueInInlineSteps();

		},

		/**
		 * Função responsável por validar os campos do modal de adição
		 * @param {*} e
		 */
		validateModalFieldsOnAdd(e) {
			this.limitQuantityNumberAfterVirgula(e.target);
			if (!this.novoObjetivo.nome || !this.novoObjetivo.porcentagem) {
				this.modalValueIsValid = false;
				this.showErrorOnModal = true;
				this.modalErrorMessage = "Os campos não podem estar vazios";
			} else if (
				this.valor_total_computado + this.novoObjetivo.porcentagem >
				100
			) {
				this.modalValueIsValid = false;
				this.showErrorOnModal = true;
				this.modalErrorMessage = "O somatório precisa ser igual a 100%";
				this.novoObjetivo.porcentagem = null;
			} else {
				this.modalValueIsValid = true;
				this.showErrorOnModal = false;
				this.modalErrorMessage = "";
			}
		},

		/**
		 * Função responsável por retornar o valor original do objetivo
		 */
		returnToOriginalValueObjetive() {
			this.novoObjetivo.porcentagem = this.objEdicao.porcentagem_desejada;
			const updatedObjectives = this.objetivos[this.step?.tipo].map((item) => {
				if (item.id === this.objEdicao.id) {
					const porcentagem =
						this.novoObjetivo.porcentagem ?? item.porcentagem_desejada;
					return { ...item, porcentagem_desejada: porcentagem };
				}
				return item;
			});
			this.objetivos[this.step?.tipo] = updatedObjectives;
			this.modalValueIsValid = true;
		},

		/**
		 * Função responsável por validar os campos do modal de edição
		 */
		validateModalFieldsOnEdit(el) {
			if (!this.novoObjetivo.porcentagem) {
				this.modalValueIsValid = false;
				this.showErrorOnModal = true;
				this.modalErrorMessage = "Os campos não podem estar vazios";
			} else if (
				this.valor_total_computado > 100 ||
				this.novoObjetivo.porcentagem > 100
			) {
				this.modalValueIsValid = false;
				this.showErrorOnModal = true;
				this.modalErrorMessage = "O somatório precisa ser igual a 100%";
				this.returnToOriginalValueObjetive();
			} else {
				this.modalValueIsValid = true;
				this.showErrorOnModal = false;
				this.modalErrorMessage = "";
			}
		},


		/**
		 * Função responsável por enviar o formulário ao final do wizard
		 * @param {*} e
		 */

		async onSubmitAction(e) {
			e.preventDefault()
			const form = this.$refs.formulario;

			form.submit();
			//add complete true
			// Object.entries(this.objetivos).map(([key, value]) => {
			// 	const objetivo = this.objetivos[key]?.reduce((acc, i, idx) => {
			// 		const { id, ...rest } = i;
			// 		acc[idx] = rest;
		// 		return acc;
			// 	}, {});


			// 	this.objetivos[key] = objetivo;
			// 	//array de objetivos


			// });


		},


		/**
		* Função responsável por resetar os campos do modal de adição
		* 
		*/

		resetModalForm() {
			this.novoObjetivo = {
				nome: "",
				porcentagem: "",
			};
		},


		handleClickInOptions(id) {
			this.showOptions = id;
			this.showOptionsFirst = true;
		},

		onCloseModal() {
			this.modalIsOpen = false;
			const valoresOriginais = this.objetivos[this.step?.tipo].map(
				(objetivo) => ({ ...objetivo })
			);
			this.objetivos[this.step?.tipo] = valoresOriginais;

			// this.setNewObjectiveValueInOnKeyupEdit(false, true);
			// this.pastTotalValue = 0;
			this.returnToOriginalValueObjetive();
			this.hasSameValue = false;
			this.showErrorOnModal = false;
			this.modalErrorMessage = "";
		},

		outsideClick({ target }) {
			if (target.closest(".icone-three-points")) return;
			this.showOptionsFirst = false;
		},
	},

	delimiters: ["{*", "*}"], //delimitadores pra n conflitar com o django
};

/* regra negócio

// updateValueStep({ currentTarget }, id, tipo = "vazio", nomeCorreto = "vazio") {
		// 	const idC = id - 1
		// 	const divPai = currentTarget.parentElement.closest(`.step-${idC}`)
		// 	console.log(divPai)
		// 	this.isPercentFull = false;
		// 	this.isValid = false;
		// 	this.showError = false;
		// 	this.modalValueIsValid = false;
		// 	this.isExclude = false
		// 	this.step = { id, tipo, nomeCorreto };
		// 	// const inputs = [...divPai.querySelectorAll('input')]
		// 	// const [input1, input2] = inputs;
		// 	this.nextStep
		// 	this.previousStep

		// 	const oi = {
		// 		'5':{
		// 			tipo: 'acoes',
		// 			nome: 'Ação'
		// 		},
		// 		'6':{
		// 			tipo: 'fiis',
		// 			nome: 'FIIs'
		// 		},
		// 		'7':{
		// 			tipo: 'stocks',
		// 			nome: 'Stock'
		// 		},
		// 		'8':{
		// 			tipo: 'reits',
		// 			nome: 'REIT'
		// 		},
		// 		'9': {
		// 			tipo: 'tesouro_direto',
		// 			nome:'Tesouro'
		// 		}

		// 	}

		// 	// 1 step
		// 	// se renda fixa 100 e renda variavel 0  => pula pro step 9
		// 	const noHaveRendaVariavel = () => this.campos_objetivo.pr_renda_variavel == 0

		// 	// 1 step
		// 	// se renda variavel for 100 e fixa for 0 => nao passa pro step 9
		// 	//  => botao submit fica no step 8
		// 	const noHaveRendaFixa = () => this.campos_objetivo.pr_renda_fixa == 0

		// 	// 2 step
		// 	// se brasil for igual a 100 e EUA for 0  nao passa no step 4
		// 	// consequentemente nao passa no 7 nem no 8

		// 	// se EUA for igual a 100 e brasil for igual a 0 nao passa no step 3
		// 	// se nao passar no step 3 consequentemente nao passa no step 5 e 6

		// 	// 3 step
		// 	// se for exibido
		// 	// se açoes for igual a 100 e FIIs for igual 0
		// 	// nao passa no step 6
		// 	// se FIIs for igual a 100 e açoes for igual a 0
		// 	// nao passa no step 5

		// 	// 4 step
		// 	// se stocks for igual a 100 e REITS for igual a 0
		// 	// nao passa no step 8
		// 	// se REITS for igual a 100 e STOCKS for igual a 0
		// 	// nao passa no step 7

		// },

		// preventMinusInsertOnInput(el) {
		// 	el.value = Math.abs(el.value);

		// },

*/
